import React from "react";
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";
import { dateToUSFormat } from '@/shared/helpers'

const ParticipantLockedInfo = ({ participant, auth, program }) => {
    const fullName = `${participant.first_name} ${participant.last_name}`
    const SUPPORT_URL =
  process.env.REACT_APP_SUPPORT_URL ||
  "https://incentco.zendesk.com/hc/en-us/requests/new";

    return (
        <>
            <Row className="mt-0">
                <Col md="12" lg="12" xl="12">
                    <h5 className="text-danger">User Account Locked</h5>
                    <span>This user account has been locked for following security reasons</span><br/>
                    <span>{participant?.is_locked_reason}</span><br/>
                    <span>To unlock your account please <a
                            href={SUPPORT_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary fw-bold"
                        >
                            Contact Support
                        </a> here.
                    </span>
                </Col>
            </Row>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        program: state.program,
    };
};

export default connect(mapStateToProps)(ParticipantLockedInfo);
